import { isAxiosError } from 'axios'

/** The shared `{ error: { code, message } }` envelope every backend error response carries (`@atlas/core-utils/router`). */
export function extractApiErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
	if (!isAxiosError(error)) return fallback
	const body = error.response?.data as { error?: { message?: string } } | undefined
	return body?.error?.message ?? fallback
}
